import { useEffect, useRef } from "react";

const useScrollToRef = (
  dependencies: any[], // "watch these values, scroll when they change"
  offset: number = 80, // gap from top (for navbar height), default 80px
) => {
  // Step 1: Create a "pointer" to a DOM element
  const ref = useRef<HTMLDivElement>(null);

  // Step 2: When any dependency changes → scroll to that element
  useEffect(() => {
    if (!ref.current) return; // safety check — element must exist

    const top =
      ref.current.getBoundingClientRect().top + // distance from viewport top
      window.scrollY - // + how much page already scrolled
      offset; // - navbar height offset

    window.scrollTo({ top, behavior: "smooth" }); // smooth scroll to final position
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps

  // Step 3: Return the ref so the component can attach it to a DOM element
  return ref;
};

export default useScrollToRef;
